// extracted by mini-css-extract-plugin
module.exports = {"inputWithBadgeWrapper":"styles_inputWithBadgeWrapper__2a-Pm","inputWrapper":"styles_inputWrapper__3VY62"};